// extracted by mini-css-extract-plugin
module.exports = {"allWrap":"Kiosk_allWrap__1Jzr3","kioskWrap":"Kiosk_kioskWrap__3Ey4A","card":"Kiosk_card__38vzL"};